<template>
<vs-prompt
          color="primary"
          @accept="submitForm"
          @close="close"
          @cancel="close"
          :active.sync="activePrompt"
          :title="$t('Team.AddTeamMemberPrompt.Title')"
          :accept-text="$t('Team.AddTeamMemberPrompt.SubmitButton')"
          :cancel-text="$t('Team.AddTeamMemberPrompt.CancelButton')"
        >
  <vs-card>
    <div v-bar class="vs-scrollable">
      <div>
        <div class="con-exemple-prompt px-4 py-3">
          <vs-row>
            <vs-col vs-w="12">
              <vs-input
                :danger="errors.lname"
                :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.LastName')})"
                :label="$t('Profile.LastName')"
                v-model="member.name"
                class="w-100 mb-2"
              />
            </vs-col>
          </vs-row>

          <vs-input
            :danger="errors.email"
            :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Email')})"
            :label="$t('Profile.Email')"
            v-model="member.email"
            class="w-100 mb-2"
          />

          <vs-row>
            <vs-col vs-w="6">
              <vs-input
                :danger="errors.password"
                :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.Password')})"
                :label="$t('Profile.Password')"
                v-model="member.password"
                type="password"
                class="w-100 mb-2"
              />
            </vs-col>
            <vs-col vs-w="6">
              <vs-input
                :danger="errors.password_confirm"
                :danger-text="$t('Errors.InvalidPolite', {field: $t('Profile.PasswordConfirm')})"
                :label="$t('Profile.PasswordConfirm')"
                type="password"
                v-model="member.password_confirm"
                class="w-100 mb-2"
              />
            </vs-col>
          </vs-row>

          <vs-select
            class="w-100 mb-2"
            :danger="errors.role"
            :danger-text="$t('Errors.Required', {field: $t('Profile.Role')})"
            :label="$t('Profile.Role')"
            v-model="member.role"
          >
            <vs-select-item
              :key="index"
              :value="item.value"
              :text="item.text"
              v-for="(item,index) in positions"
            />
          </vs-select>

          <vs-select
            class="w-100 mb-2"
            :label="$t('Profile.Department')"
            v-if="departments.length"
            v-model="department"
          >
            <vs-select-item
              :key="index"
              :value="item.id"
              :text="item.name"
              v-for="(item,index) in departments"
            />
          </vs-select>
        </div>
      </div>
    </div>
  </vs-card>
</vs-prompt>
</template>
<script>
import router from '../../_helpers/router.js' 
import { teamService} from "../../_services";
export default {
  name: "AddMember",
  data: () => ({
    title: "AddMember"
    ,member : {
      name : "",
      email :"",
      password:"",
      password_confirm  : "",
      role : "",
      type :"SUPER"
    }
    ,
    positions : [],
    departments : [],
    business:[],
    errors:{
      fname : false,
      lname : false,
      telephone : false,
      email : false,
      password : false,
      password_confirm : false,
      role : false,
      selected:{
        fname : false,
        lname : false,
        telephone : false,
        email : false,
        password : false,
        password_confirm : false,
        role : false,
      }
    }
  }),
  props: {
    activePrompt : Boolean
  },
  methods: {
    close() {
      this.member.fname = "";
      this.member.name = "";
      this.member.telephone = "";
      this.member.email = "";
      this.member.password = "";
      this.member.password_confirm = "";
      this.member.role = "";
      this.activePrompt=false;
    },
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text
      });
    },
    getAllTeamMember(){
teamService.getAll(function(data){
  this.business=data.business.data;
console.log(data);
})
 },
    submitForm() {
      console.log("Form well submited");
           let self=this;
      teamService.addTeamMember(this.member).then(function(data){
        console.log(data);
            self.$vs.notify({title: 'success',text: 'account successfully added', position: 
         'bottom-right', type: 'success' ,color:'green' });

router.go();
            

      }).bind(this);
    },
    
    validateFields() {
      this.errors.lname = !this.lname || this.lname.length < 3 ? true : false;
      this.errors.telephone = !(
        this.telephone.length < 3 || !this.isValidPhoneNumber(this.telephone)
      )
        ? false
        : true;
      this.errors.password = this.password ? false : true;
      this.errors.password_confirm = this.password_confirm
        ? this.password == this.password_confirm
          ? false
          : true
        : true;
      this.errors.role = this.role ? false : true;
      if (this.email.length > 0) {
        this.errors.email = this.isValidEmail(this.email) ? false : true;
      } else {
        this.errors.email = false;
      }

      let {
        fname,
        lname,
        telephone,
        email,
        password,
        password_confirm,
        role
      } = this.errors;
      return !(
        fname ||
        lname ||
        telephone ||
        email ||
        password ||
        password_confirm ||
        role
      );
    }
  }
    
}
</script>